"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dataCell_1 = __importDefault(require("../dataCell"));
const dataTable_1 = __importDefault(require("../dataTable"));
class CSVParser {
    constructor() {
        this.fileTypes = [
            'text/plain',
            'text/csv',
            'csv',
            'application/vnd.ms-excel',
            'application/csv',
            'application/x-csv',
            'text/comma-separated-values',
            'text/x-comma-separated-values',
            'text/tab-separated-values'
        ];
    }
    parse(content) {
        return __awaiter(this, void 0, void 0, function* () {
            let header = [];
            let data = [];
            let setHeader = false;
            const lines = content.split('\n');
            for (const line of lines) {
                const cells = yield this.parseLine(line);
                if (!setHeader) {
                    header = cells;
                    setHeader = true;
                }
                else {
                    if (cells.length === header.length) {
                        data.push(cells.map(cell => new dataCell_1.default(cell)));
                    }
                }
            }
            return new dataTable_1.default(header, data);
        });
    }
    parseLine(line) {
        return __awaiter(this, void 0, void 0, function* () {
            const regex = /(?!\B"[^"]*),(?![^"]*"\B)/g;
            return line.replace('\r', '').replace('\\', '').split(regex).map((cell) => {
                if (cell[0] === '"' && cell[cell.length - 1] === '"') {
                    cell = cell.substr(1, cell.length - 2);
                }
                return cell;
            });
        });
    }
}
exports.default = CSVParser;
